import * as React from "preact";
import { render } from "preact";

import App from "./App"; // eslint-disable-line @typescript-eslint/no-unused-vars

function init() {
  const el = document.getElementById("cashhubtable-app");
  if (el) {
    const { apiUrl, pageSize, enableFiltering, fscsAmount } = el.dataset;
    const filter = JSON.parse(enableFiltering.toLowerCase());
    if (apiUrl) {
      render(
        <App
          apiUrl={apiUrl}
          pageSize={Number(pageSize)}
          enableFiltering={filter}
          fscsAmount={Number(fscsAmount)}
        />,
        el
      );
    }
  }
}

export default { init };
